var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ui-dropdown',_vm._b({attrs:{"items":_vm.dropdownItems,"multiselect":_vm.multiselect,"autocomplete":_vm.autocomplete,"scroll":_vm.scroll,"required":_vm.required},on:{"change":_vm.onDropdownChanged,"changeAutocomlite":_vm.changeAutocomlite}},'ui-dropdown',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }